<!-- set view box width large enough to include whole logo -->
<svg #svgLogoParent width="100%" height="100%" viewBox="0 0 500 32" version="1.1">
    <defs>
        <g id="oriLogoOutlined">
            <path
                id="ori1"
                fill="var(--color-ori-1)"
                d="M15.2517321,0.773846154 C11.0879464,0.773846154 6.9785,2.43384615 4.08333929,5.68276923 C1.48841071,8.66984615 0.273821429,12.624 0.665732143,16.8141538 C1.05794643,21.0110769 3.00808929,24.8873846 6.15673214,27.7298462 C9.24283929,30.452 13.1115536,31.7286154 17.0494821,31.3246154 C21.0347679,30.9144615 24.6166071,28.8476923 27.1347321,25.5052308 C32.3306607,18.7809231 31.4897679,9.50246154 25.2234464,4.37938462 L25.2207143,4.37723077 C22.3288929,1.96092308 18.7710357,0.773846154 15.2517321,0.773846154 Z M15.6175357,32 C12.0396429,32 8.58773214,30.672 5.76451786,28.1812308 C2.501125,25.2356923 0.481160714,21.2193846 0.0746785714,16.8710769 C-0.332714286,12.5138462 0.933785714,8.39815385 3.64042857,5.28246154 C9.19426786,-0.950461538 19.0424286,-1.564 25.5968393,3.91169231 C32.1175536,9.244 32.9997321,18.8904615 27.6043571,25.8732308 C24.987875,29.3464615 21.2597143,31.4956923 17.1095893,31.9230769 C16.6108214,31.9744615 16.1129643,32 15.6175357,32 L15.6175357,32 Z"
            ></path>
            <path
                id="ori2"
                fill="var(--color-ori-2)"
                d="M17.7009464,3.25846154 C14.656125,3.25846154 11.6507679,4.472 9.53396429,6.84769231 C5.60483929,11.3707692 6.30032143,18.8206154 11.0551607,23.1123077 C13.2660714,25.0627692 16.0504286,25.9781538 18.8906429,25.6843077 C21.804625,25.3846154 24.5382857,23.8027692 26.390375,21.3446154 C30.1904821,16.4261538 29.5769643,9.64184615 24.9957679,5.89630769 L24.9930357,5.89415385 C22.87775,4.12646154 20.2749286,3.25846154 17.7009464,3.25846154 Z M17.8509107,26.3396923 C15.2332143,26.3396923 12.7150893,25.3744615 10.6629464,23.5636923 C5.66676786,19.0538462 4.94791071,11.2166154 9.09105357,6.44738462 C13.2093036,1.82523077 20.5108036,1.36984615 25.3697679,5.42923077 C30.20475,9.38369231 30.8598571,16.536 26.86,21.7126154 C24.9107679,24.2996923 22.0274464,25.9664615 18.95075,26.2830769 C18.583125,26.3212308 18.2158036,26.3396923 17.8509107,26.3396923 L17.8509107,26.3396923 Z"
            ></path>
            <path
                id="ori3"
                fill="var(--color-ori-3)"
                d="M19.1031429,5.35076923 C16.8142143,5.35076923 14.5556429,6.26492308 12.964625,8.05446154 C9.98871429,11.488 10.5026607,16.9403077 14.1124286,20.2061538 C15.8060536,21.7036923 17.9292321,22.408 20.091875,22.1852308 C22.2815357,21.96 24.2498929,20.8215385 25.6344821,18.9796923 C28.4923036,15.2726154 28.0317857,10.1606154 24.5886786,7.33938462 L24.58625,7.33723077 C22.9955357,6.00492308 21.0384107,5.35076923 19.1031429,5.35076923 Z M19.3074464,22.827077 C17.2777679,22.8273846 15.3200357,22.0723077 13.7199107,20.6572308 C9.86516071,17.1701538 9.32844643,11.3381538 12.5211071,7.65476923 C15.66975,4.11292308 21.2496964,3.76369231 24.9632857,6.87261538 C28.6595714,9.90276923 29.1610714,15.3818462 26.1044107,19.3473846 C24.6214643,21.32 22.5064821,22.5415385 20.1516786,22.7836923 C19.8693571,22.8126154 19.5876429,22.827077 19.3074464,22.827077 L19.3074464,22.827077 Z"
            ></path>
        </g>
        <g id="labcorpText">
            <polygon
                id="lc-l-char"
                points="37.9573571 22.7726154 41.2675 22.7726154 41.2675 4.89569231 37.9573571 4.89569231"
            ></polygon>

            <path
                id="lc-a-char"
                d="
                    M49.1670357,19.9809231
                    C50.4475,19.9809231 51.2206964,19.4178462 51.7762321,18.6341538
                    L51.7762321,14.6421538
                    C51.2206964,13.8833846 50.4475,13.32 49.1670357,13.32
                    C47.379,13.32 46.1468036,14.8384615 46.1468036,16.6504615
                    C46.1468036,18.4627692 47.379,19.9809231 49.1670357,19.9809231
                    Z
                    M48.68375,23.0421538
                    C45.1076786,23.0421538 42.7158393,20.0787692 42.7158393,16.6504615
                    C42.7158393,13.2218462 45.1076786,10.2587692 48.68375,10.2587692
                    C49.9885,10.2587692 51.0755893,10.7243077 51.7762321,11.4098462
                    L51.7762321,10.5283077 L55.086375,10.5283077
                    L55.086375,22.7726154 L51.7762321,22.7726154
                    L51.7762321,21.8667692 C51.0755893,22.5769231 49.9885,23.0421538 48.68375,23.0421538
                    L48.68375,23.0421538
                    Z"
            ></path>

            <path
                id="lc-b-char"
                d="
                    M63.0153571,19.9809231
                    C64.827375,19.9809231 66.0595714,18.4627692 66.0595714,16.6504615
                    C66.0595714,14.8384615 64.827375,13.32 63.0153571,13.32
                    C61.7345893,13.32 60.9616964,13.8833846 60.4061607,14.6421538
                    L60.4061607,18.6341538
                    C60.9616964,19.4178462 61.7345893,19.9809231 63.0153571,19.9809231
                    Z
                    M63.4986429,23.0421538
                    C62.217875,23.0421538 61.1065,22.5769231 60.4061607,21.8667692
                    L60.4061607,22.7726154
                    L57.0957143,22.7726154
                    L57.0957143,4.89569231
                    L60.4061607,4.89569231
                    L60.4061607,11.4098462
                    C61.1065,10.7243077 62.217875,10.2587692 63.4986429,10.2587692
                    C67.0741071,10.2587692 69.46625,13.2218462 69.46625,16.6504615
                    C69.46625,20.0787692 67.0741071,23.0421538 63.4986429,23.0421538
                    L63.4986429,23.0421538
                    Z"
            ></path>

            <path
                id="lc-c-char"
                d="
                    M76.9523214,23.0421538
                    C73.3765536,23.0421538 70.55,20.3483077 70.55,16.6504615
                    C70.55,12.9526154 73.3765536,10.2587692 76.9523214,10.2587692
                    C79.4652857,10.2587692 81.6397679,11.6793846 82.6785893,13.7852308
                    L79.8034643,15.3526154
                    C79.3201786,14.2261538 78.2810536,13.3935385 76.9523214,13.3935385
                    C75.2128571,13.3935385 73.884125,14.7646154 73.884125,16.6504615
                    C73.884125,18.536 75.2128571,19.9076923 76.9523214,19.9076923
                    C78.2810536,19.9076923 79.3201786,19.0750769 79.8034643,17.9483077
                    L82.6785893,19.5156923
                    C81.6397679,21.6218462 79.4652857,23.0421538 76.9523214,23.0421538"
            ></path>

            <path
                id="lc-o-char"
                d="
                    M89.7074821,19.9076923
                    C91.4469464,19.9076923 92.703125,18.536 92.703125,16.6504615
                    C92.703125,14.7646154 91.4469464,13.3935385 89.7074821,13.3935385
                    C87.9680179,13.3935385 86.68725,14.7646154 86.68725,16.6504615
                    C86.68725,18.536 87.9680179,19.9076923 89.7074821,19.9076923
                    Z
                    M89.7074821,23.0421538
                    C86.2039643,23.0421538 83.3528214,20.2258462 83.3528214,16.6504615
                    C83.3528214,13.0750769 86.2039643,10.2587692 89.7074821,10.2587692
                    C93.2106964,10.2587692 96.0618393,13.0750769 96.0618393,16.6504615
                    C96.0618393,20.2258462 93.2106964,23.0421538 89.7074821,23.0421538
                    L89.7074821,23.0421538
                    Z"
            ></path>

            <path
                id="lc-r-char"
                d="
                    M103.613482,10.3812308
                    C102.357,10.3812308 101.221643,11.1156923 100.810607,11.9975385
                    L100.810607,10.5283077
                    L97.5004643,10.5283077
                    L97.5004643,22.7726154
                    L100.810607,22.7726154
                    L100.810607,15.1947692
                    C102.3825,12.884 105.014768,13.8166154 105.014768,13.8166154
                    L105.014768,10.6018462
                    C104.748839,10.5036923 104.217286,10.3812308 103.613482,10.3812308"
            ></path>

            <!-- 118 is the far side of the P -->
            <path
                id="lc-p-char"
                d="
                M112.382446,19.9809231
                C114.194464,19.9809231 115.426964,18.4627692 115.426964,16.6504615
                C115.426964,14.8384615 114.194464,13.32 112.382446,13.32
                C111.101982,13.32 110.328786,13.8833846 109.77325,14.6421538
                L109.77325,18.6341538
                C110.328786,19.4178462 111.101982,19.9809231 112.382446,19.9809231
                Z
                M106.463107,10.5283077
                L109.77325,10.5283077
                L109.77325,11.4098462
                C110.473893,10.7243077 111.584964,10.2587692 112.865732,10.2587692
                C116.4415,10.2587692 118.833339,13.2218462 118.833339,16.6504615
                C118.833339,20.0787692 116.4415,23.0421538 112.865732,23.0421538
                C111.584964,23.0421538 110.473893,22.5769231 109.77325,21.8667692
                L109.77325,27.5236923
                L106.463107,27.5236923
                L106.463107,10.5283077
                L106.463107,10.5283077
                Z"
            ></path>
        </g>
    </defs>

    <g id="logoContainer" stroke="none" stroke-width="1" class="logo color-logo">
        <g id="logoWithoutTm" #logoWithoutTm>
            <use href="#oriLogoOutlined"></use>
            <use href="#labcorpText" fill="var(--primary)"></use>
            /* x coordinate is coordinate of the far right side of the 'p' rounded plus 10. */
            <rect
                id="RectangleSeparator"
                x="129"
                y="5"
                width="1"
                height="22"
                fill="var(--color-separator)"
            ></rect>
            /* The x coordinate represents the distance between the vertical separator and the 'P'
            plus the x origin of the vertical separator. The y coordinate represents the y
            coordinate of the starting point of the 'l' character */
            <text
                #appNameText
                id="appNameText"
                transform="translate(139, 22.7726154)"
                fill="var(--color-app-name)"
                text-anchor="start"
                class="app-name-text"
            >
                {{ _appName }}
                <tspan id="TM" x="" y="-10" class="tm-text">™</tspan>
            </text>
        </g>
    </g>
</svg>
